<app-side-dialog class="overflow-hidden" [contentMarginTop]="16" [disableClose]="true" (closeDialog)="onCloseClick()">
  <div dialogHeader class="flex w-full">
    <h2
      class="line-clamp-1 max-w-[608px] text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="ctaForm()?.get('name')?.value ?? ''"
    >
      @if (createMode()) {
        {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.title' | translate }}
      } @else {
        {{
          'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.editTitle'
            | translate: { name: ctaForm()?.get('name')?.value }
        }}
      }
    </h2>
  </div>

  <div dialogContent>
    <div class="flex flex-col gap-4 sticky top-0 z-10 bg-shikenso-base-white">
      <div class="grid grid-cols-[max-content_minmax(0,1fr)] items-center gap-x-2 gap-y-3">
        <span class="text-xl">
          {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.creatorSelectMenu.appliedTo' | translate }}:
        </span>
        <app-creator-select-menu
          class="min-w-0"
          [campaignCreatorsValue]="campaignCreatorsValue()"
          [ctaForm]="ctaForm()"
          [initialCreators]="initialCreators()"
          [selectedPlatform]="selectedPlatform()"
          [templateSelectedCreatorIds]="templateSelectedCreatorIds()"
          (selectedCreatorIdsChange)="updateSelectedCreatorIds($event)"
          [(customModeCreatorId)]="customModeCreatorId"
        />

        @if (customModeCreatorId() && step() !== EDeliverableFlowStep.platform) {
          <span class="text-xl">{{ 'components.customCreatorBadge.editing' | translate }}:</span>
          <app-custom-creator-badge
            class="min-w-0"
            [existingCtaForm]="ctaForm()"
            [campaignCreatorsValue]="campaignCreatorsValue()"
            [creatorId]="customModeCreatorId()"
            (customModeDisabled)="customModeCreatorId.set(null)"
          />
        }
      </div>

      <div class="df-step-navigation">
        @for (headerStep of headerSteps; track headerStep.step; let index = $index; let isLast = $last) {
          <div class="df-step-item">
            <div class="flex items-center">
              <button
                type="button"
                class="df-step-button"
                [class.is-active]="isHeaderStepActive(headerStep.step)"
                [class.is-clickable]="isHeaderStepClickable(headerStep.step)"
                [class.is-completed]="isHeaderStepCompleted(headerStep.step)"
                [class.is-upcoming]="!isHeaderStepActive(headerStep.step) && !isHeaderStepCompleted(headerStep.step)"
                [disabled]="!isHeaderStepClickable(headerStep.step)"
                (click)="onHeaderClick(headerStep.step)"
              >
                <span class="df-step-indicator">
                  @if (isHeaderStepCompleted(headerStep.step)) {
                    <span class="df-step-check-icon"></span>
                  } @else {
                    {{ index + 1 }}
                  }
                </span>

                <span class="df-step-label">{{ headerStep.label }}</span>
              </button>
            </div>

            @if (!isLast) {
              <span class="df-step-connector" [class.is-completed]="selectedStepIndex() > index"></span>
            }
          </div>
        }
      </div>

      <hr class="border-transparent" />
    </div>

    <mat-stepper class="df-stepper" [linear]="false" (selectionChange)="onSelectionChange($event)">
      <mat-step [hasError]="!selectedPlatformFeature()">
        <app-platform-step
          [campaignCreatorsValue]="campaignCreatorsValue()"
          [ctaForm]="ctaForm()"
          [selectedPlatformFeature]="selectedPlatformFeature()"
          [selectedCreatorIds]="selectedCreatorIds()"
          (globalTemplateSelected)="onPlatformTemplateSelected($event)"
          (platformFeatureChanged)="onPlatformFeatureChange($event)"
          (deliverableConfigurationsChanged)="deliverableConfigurations.set($event)"
          (newPlatformAddedCreatorIds)="newPlatformAddedCreatorIds.set($event)"
        />
      </mat-step>

      <mat-step [stepControl]="ctaForm()!">
        <app-deliverable-step
          [campaignCreatorsValue]="campaignCreatorsValue()"
          [ctaForm]="ctaForm()"
          [selectedPlatformFeature]="selectedPlatformFeature()"
          [deliverableConfigurations]="deliverableConfigurations()"
          [customModeCreatorId]="customModeCreatorId()"
          [executionValues]="executionValues()"
          (customModeDisabled)="customModeCreatorId.set(null)"
        />
      </mat-step>

      <mat-step [stepControl]="ctaForm()!">
        <app-execution-step
          [campaignCreatorsValue]="campaignCreatorsValue()"
          [selectedPlatformFeature]="selectedPlatformFeature()"
          [ctaForm]="ctaForm()"
          [customModeCreatorId]="customModeCreatorId()"
          [reached]="highestReachedStepIndex() >= STEP_INDEXES[EDeliverableFlowStep.execution]"
          [gamePlayValues]="gamePlayValues()"
          (customModeDisabled)="customModeCreatorId.set(null)"
        />
      </mat-step>

      <mat-step [stepControl]="ctaForm()!">
        <app-expected-kpi-step
          [campaignCreatorsValue]="campaignCreatorsValue()"
          [selectedPlatformFeature]="selectedPlatformFeature()"
          [createMode]="createMode()"
          [ctaForm]="ctaForm()"
          [customModeCreatorId]="customModeCreatorId()"
          [reached]="highestReachedStepIndex() >= STEP_INDEXES[EDeliverableFlowStep.kpis]"
          [gamePlayValues]="gamePlayValues()"
          (customModeDisabled)="customModeCreatorId.set(null)"
        />
      </mat-step>

      <mat-step [stepControl]="ctaForm()!">
        <app-review-step
          [ctaForm]="ctaForm()"
          [customModeCreatorId]="customModeCreatorId()"
          [selectedPlatformFeature]="selectedPlatformFeature()"
        />
      </mat-step>
    </mat-stepper>

    <div class="df-dialog-footer">
      @if (selectedStepIndex() === 4) {
        <div class="flex justify-center w-full">
          <button mat-flat-button type="button" color="primary" (click)="onSaveAndExitClick()">
            {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.reviewStep.finish' | translate }}
            @if (customModeCreatorId()) {
              <span> &nbsp;({{ 'shared.override' | translate }}) </span>
            }
          </button>
        </div>
      } @else {
        <hr class="border-shikenso-purple-base-12" />
        <div class="flex items-center justify-between">
          <button
            mat-flat-button
            type="button"
            color="secondary"
            [disabled]="isSaveAndExitDisabled()"
            (click)="onSaveAndExitClick()"
          >
            {{ 'shared.form.saveAndExit' | translate }}
            @if (customModeCreatorId() && selectedStepIndex() > 0) {
              <span> &nbsp;({{ 'shared.override' | translate }}) </span>
            }
          </button>
          <div class="flex items-center gap-3">
            <button mat-flat-button type="button" color="secondary-transparent" (click)="onCloseClick()">
              {{ 'shared.cancel' | translate }}
            </button>
            <button
              mat-flat-button
              type="button"
              color="primary"
              [disabled]="isContinueDisabled"
              (click)="onContinueClick()"
            >
              {{ 'shared.continue' | translate }}
              @if (customModeCreatorId() && selectedStepIndex() > 0) {
                <span> &nbsp;({{ 'shared.override' | translate }}) </span>
              }
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</app-side-dialog>
